import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
    IsFollowerOfCreativeSetResponse,
    ShowcaseFollowCreativeSetRequest,
    ShowcaseUnfollowCreativeSetRequest
} from '@bannerflow/types.notification-orchestrator';
import { EnvironmentService } from '@studio/common/services/environment.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FollowCreativeSetDataService {
    private httpClient = inject(HttpClient);
    private environmentService = inject(EnvironmentService);
    private API_URL = this.environmentService.origins.notificationOrchestratorService;

    getIsFollower(creativeSetId: number): Observable<IsFollowerOfCreativeSetResponse> {
        const url = `${this.API_URL}/creative-sets/${creativeSetId}/is-follower`;
        return this.httpClient.get<IsFollowerOfCreativeSetResponse>(url);
    }

    putFollow(creativeSetId: number): Observable<void> {
        const url = `${this.API_URL}/creative-sets/${creativeSetId}/follow`;
        return this.httpClient.put<void>(url, null);
    }

    putUnfollow(creativeSetId: number): Observable<void> {
        const url = `${this.API_URL}/creative-sets/${creativeSetId}/unfollow`;
        return this.httpClient.put<void>(url, null);
    }

    getShowcaseIsFollower(
        creativeSetId: number,
        userEmail: string
    ): Observable<IsFollowerOfCreativeSetResponse> {
        const url = `${this.API_URL}/showcase/creative-sets/${creativeSetId}/is-follower?userEmail=${userEmail}`;
        return this.httpClient.get<IsFollowerOfCreativeSetResponse>(url);
    }

    putShowcaseFollow(creativeSetId: number, userEmail: string, userName: string): Observable<void> {
        const url = `${this.API_URL}/showcase/creative-sets/${creativeSetId}/follow`;
        const body: ShowcaseFollowCreativeSetRequest = {
            userEmail,
            userName
        };
        return this.httpClient.put<void>(url, body);
    }

    putShowcaseUnfollow(creativeSetId: number, userEmail: string): Observable<void> {
        const url = `${this.API_URL}/showcase/creative-sets/${creativeSetId}/unfollow`;
        const body: ShowcaseUnfollowCreativeSetRequest = { userEmail };
        return this.httpClient.put<void>(url, body);
    }
}
